import { privateAxios } from '../requestsCollection';
import { IResponse } from '../types';
import {
  IAddCrisisAllocationPayload,
  ICrisisAllocation,
  ICrisisCall,
  ICrisisCallsAllocatedClients,
  IEditCrisisAddressPayload,
} from './types';

export const addCrisisAllocation = (
  clinicId: string,
  data: IAddCrisisAllocationPayload,
): IResponse<ICrisisAllocation> =>
  privateAxios(
    {
      method: 'post',
      url: `clinic/${clinicId}/crisis-allocation`,
      data,
    },
    'v3',
  );

export const deleteCrisisAllocation = (clinicId: string, id: number): IResponse<void> =>
  privateAxios(
    {
      method: 'delete',
      url: `clinic/${clinicId}/crisis-allocation/${id}`,
    },
    'v3',
  );

export const editCrisisAllocation = (
  clinicId: string,
  id: string,
  memo: string,
): IResponse<ICrisisAllocation> =>
  privateAxios(
    {
      method: 'put',
      url: `clinic/${clinicId}/crisis-allocation/${id}`,
      data: { memo },
    },
    'v3',
  );

export const getCrisisCalls = (
  clinicId: string,
): IResponse<{ crisisCalls: ICrisisCall[]; allocatedClients: ICrisisCallsAllocatedClients[] }> =>
  privateAxios({
    method: 'get',
    url: `clinic/${clinicId}/crisis-call`,
  });

export const editCrisisAddress = (
  clinicId: number,
  id: number,
  data: IEditCrisisAddressPayload,
): IResponse<ICrisisCall> =>
  privateAxios({
    method: 'put',
    url: `clinic/${clinicId}/crisis-call/${id}/address`,
    data,
  });

export default {};
